<div class="overview-my-products-container">
  <h2>My Products</h2>
  <ul>
    @for (product of productLogos; track $index; let i = $index) {
      <li>
        <img id="programLogo_{{i}}"
          [ngSrc]="getProductLogoPath(product)"
          fill
          [alt]="product.name"
          />
      </li>
    }
  </ul>
</div>
